module.exports = __webpack_public_path__ + "static/img/Logo_DCT.823e43e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Logo_DCT.jpg
// module id = T96U
// module chunks = 51